<template>
  <div class="inline-flex items-center w-full">
    <div style="width: 60px; heigth: 60px;">
      <div
        src="/images/back.svg"
        style="height: auto; width: 20px;"
        class="dark:text-slate-50"
        @click="clearItineraire()"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="feather feather-arrow-left"
        >
          <line x1="19" y1="12" x2="5" y2="12"></line>
          <polyline points="12 19 5 12 12 5"></polyline>
        </svg>
      </div>
    </div>
    <div class="inline-flex flex-col justify-center items-center w-full ">
      <div class="relative text-gray-800 rounded-full w-full mb-2 ">
        <input
          @input="searchFrom"
          :value="
            $store.state.itineraire.selected.from
              ? $store.state.itineraire.selected.from.place_name_fr
              : ''
          "
          type="search"
          placeholder="Choisir un point de départ"
          class="h-10 px-5 pl-10 text-sm rounded-full focus:outline-none cursor-text w-full dark:bg-[#27282a] dark:text-white"
        />
        <div
          class="absolute left-0 top-0 mt-3 ml-4 cursor-pointer dark:text-slate-50"
        >
          <svg
            class="h-4 w-4 fill-current"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            version="1.1"
            id="Capa_1"
            x="0px"
            y="0px"
            viewBox="0 0 56.966 56.966"
            style="enable-background:new 0 0 56.966 56.966;"
            xml:space="preserve"
            width="512px"
            height="512px"
          >
            <path
              d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z"
            />
          </svg>
        </div>
      </div>
      <div class="relative text-gray-800 rounded-full w-full">
        <input
          @input="searchTo"
          :value="
            $store.state.itineraire.selected.to
              ? $store.state.itineraire.selected.to.place_name_fr
              : ''
          "
          type="search"
          placeholder="Choisir une destination"
          class="h-10 px-5 pl-10 text-sm rounded-full focus:outline-none cursor-text w-full dark:bg-[#27282a] dark:text-white"
        />
        <div class="absolute left-0 top-0 mt-3 ml-4 cursor-pointer">
          <div style="height: auto; width: 18px;" class="dark:text-slate-50">
            <svg
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              version="1.1"
              x="0px"
              y="0px"
              viewBox="0 0 64 64"
              enable-background="new 0 0 64 64"
              xml:space="preserve"
            >
              <g>
                <g>
                  <path
                    d="M52,23.41C52,12.14,43.05,3,32,3s-20,9.14-20,20.41C12,40.4,32,61,32,61S52,40.4,52,23.41z M22.5,22.5    c0-5.25,4.25-9.5,9.5-9.5s9.5,4.25,9.5,9.5S37.25,32,32,32S22.5,27.75,22.5,22.5z"
                  ></path>
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="-mr-4 dark:text-slate-50" @click="reverse()">
      <svg
        style="height: auto; width: 60px;"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="100"
        height="100"
        viewBox="0 0 100 100"
      >
        <g
          transform="translate(50 50) scale(0.69 0.69) rotate(90) translate(-50 -50)"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 1"
            viewBox="0 0 100 100"
            x="0px"
            y="0px"
          >
            <title>work_export_210718</title>
            <path
              d="M28,39H66.67l-3.59,3.59a2,2,0,1,0,2.83,2.83l7-7a2,2,0,0,0,0-2.83l-7-7a2,2,0,0,0-2.83,2.83L66.67,35H28A2,2,0,0,0,28,39Z"
            ></path>
            <path
              d="M72.08,61H33.33l3.58-3.58a2,2,0,0,0-2.83-2.83l-7,7a2,2,0,0,0,0,2.83l7,7a2,2,0,0,0,2.83-2.83L33.32,65H72.08A2,2,0,0,0,72.08,61Z"
            ></path>
          </svg>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      apiKey:
        "pk.eyJ1IjoiYXBleHNlYXJjaHVzZXIiLCJhIjoiY2pxc2V6bjVyMHVxcjQ4cXE4cmg1a242diJ9.TMZ9oWhH_fF4ccYkaMeyAw&cachebuster=1591447920479",
      excludedCategories: [
        "bus station, bus stop, bus",
        "rail station, train station"
      ]
    };
  },
  computed: {
    onSearch() {
      const { onSearch, query } = this.$store.state.itineraire;
      return onSearch && query;
    }
  },
  methods: {
    queryOld(dir, search) {
      const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURI(
        search
      )}.json?access_token=${
        this.apiKey
      }&autocomplete=true&country=fr&types=address%2Clocality%2Cplace%2Cpoi&bbox=2.9477760586852955%2C45.67761094654096%2C3.2828590664977417%2C45.86966229436986&language=fr`;

      fetch(url)
        .then(r => r.json())
        .then(json => {
          const features = json.features.filter(
            item => !this.excludedCategories.includes(item.properties.category)
          );
          this.$store.commit("itineraireSearch", { dir, value: features });
        });
    },
    query(dir, search) {
      const url = `https://t2c.bullshit.video/places/${search}`;
      //const url = `http://localhost:8000/places/${search}`;
      fetch(url)
        .then(r => r.json())
        .then(data => {
          this.$store.commit("itineraireSearch", { dir, value: data });
        });
    },
    searchFrom(e) {
      const { value } = e.target;
      if (value) {
        this.$store.commit("itineraireQuery", value);
        const result = this.query("from", value);
        console.log("searchFrom", result);
      }
    },
    searchTo(e) {
      const { value } = e.target;
      if (value) {
        this.$store.commit("itineraireQuery", value);
        const result = this.query("to", value);
        console.log("searchTo", result);
      }
    },
    clearItineraire() {
      this.$store.commit("clearItineraire");
      // Search is open -> go to itineraire
      if (this.onSearch) {
        this.$store.commit("clearItineraire");
        this.$store.commit("openTravel", null);
        return;
      }

      // back from itinereaire -> go to home
      this.$router.push("/");
    },
    async reverse() {
      this.$store.commit("itineraireReverse");
      await this.$store.dispatch("findJourney");
    }
  }
};
</script>
